import { takeLatest, put, call, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import {
  getPatientRxMedicationsById,
  createPatientRxMedications,
  updatePatientRxMedicationsById,
  getPatientRxMedicationsByIdSuccess,
  getPatientsActiveAllergies,
  getPatientsCurrentMedications,
  getPatientsActiveAllergiesSuccess,
  getPatientsCurrentMedicationsSuccess,
  getAppointmentMedicationsById,
  getAppointmentMedicationsByIdSuccess,
  showMedicationSummary,
} from './slice';
import { chrApi, phrApi, phrServiceApi } from '../../api/api';
import { showLoader } from '../globalReducer';
import { apiErrorHandler } from '../Utils/apiErrorHandler';
import { getAddedMedicationsSelector } from './selectors';

function fetchPatientRxMedicationsByIdApi(patientId) {
  return chrApi('get', `rx_medication/patient/${patientId}`, null, null);
}
function* fetchPatientRxMedicationsById(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchPatientRxMedicationsByIdApi, action.payload.patientId);
    yield put(showLoader(false));
    yield put(getPatientRxMedicationsByIdSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchPatientRxMedicationsByIdSaga() {
  yield takeLatest(getPatientRxMedicationsById.type, fetchPatientRxMedicationsById);
}

function postCreateRxMedicationsApi(data) {
  return chrApi('post', 'rx_medication', data, null);
}
function* postCreateRxMedications(action) {
  try {
    const { isPatient, patientId } = action.payload;
    const data = yield select(getAddedMedicationsSelector);
    yield put(showLoader(true));
    yield call(postCreateRxMedicationsApi, data);
    yield put(showLoader(false));
    toast.success('Medication Successfully Created');
    yield put(showMedicationSummary());
    // if (isPatient === 'true') {
    //   yield put(push(`/patient/${patientId}`));
    // } else {
    //   yield put(push('/appointment'));
    // }
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* postCreateRxMedicationsSaga() {
  yield takeLatest(createPatientRxMedications.type, postCreateRxMedications);
}

function putPatientRxMedicationByIdApi() {
  return chrApi('put', 'rx_medication/patient/patientId');
}
function* putPatientRxMedicationById(action) {
  try {
    yield put(showLoader(true));
    const apiResponse = yield call(putPatientRxMedicationByIdApi, action.payload);
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* putPatientRxMedicationByIdSaga() {
  yield takeLatest(updatePatientRxMedicationsById.type, putPatientRxMedicationById);
}

function fetchPatientsActiveAllergiesApi(chrPatientId) {
  return phrServiceApi('get', `patient_active_allergies/${chrPatientId}`, null, null);
}
function* fetchPatientsActiveAllergies(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchPatientsActiveAllergiesApi, action.payload.patientId);
    yield put(showLoader(false));
    yield put(getPatientsActiveAllergiesSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchPatientsActiveAllergiesSaga() {
  yield takeLatest(getPatientsActiveAllergies.type, fetchPatientsActiveAllergies);
}

function fetchPatientsCurrentMedicationsApi(chrPatientId) {
  return phrServiceApi('get', `patient_active_medications/${chrPatientId}`, null, null);
}
function* fetchPatientsCurrentMedications(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchPatientsCurrentMedicationsApi, action.payload.patientId);
    yield put(showLoader(false));
    yield put(getPatientsCurrentMedicationsSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchPatientsCurrentMedicationsSaga() {
  yield takeLatest(getPatientsCurrentMedications.type, fetchPatientsCurrentMedications);
}

function fetchAppointmentMedicationsByIdApi(appointmentId) {
  return chrApi('get', `rx_medication/appointment/${appointmentId}`, null, null);
}

function* fetchAppointmentMedicationsById(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchAppointmentMedicationsByIdApi, action.payload.appointmentId);
    yield put(showLoader(false));
    yield put(getAppointmentMedicationsByIdSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchAppointmentMedicationsByIdSaga() {
  yield takeLatest(getAppointmentMedicationsById.type, fetchAppointmentMedicationsById);
}
